import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";

const coloresAsignados = {};
const getColor = (key) => {
  if (!coloresAsignados[key]) {
    const colorAleatorio = `#${Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, "0")}`;
    coloresAsignados[key] = colorAleatorio;
  }
  return coloresAsignados[key];
};

function Dialog_evolucion({ abrirDialog, onClose, datosGrafico,sucursalesSeleccionadas }) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const dataset = datosGrafico;
  const articulos =
    dataset.length > 0
      ? Object.keys(dataset[0]).filter((k) => k !== "mes")
      : [];

  const chartSetting = {
    yAxis: [
      {
        label: "Cantidad enviada",
      },
    ],
    width: 650,
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-20px, 0)",
      },
    },
  };

  const customize = {
    legend: { hidden: true },
  };

  const valueFormatter = (value) => `${value}`;

  if (!datosGrafico || !dataset || dataset.length === 0) return null;

  // const valoresPorArticulo = dataset.length > 0 ? dataset[0] : {};
  const valoresPorArticulo = dataset[0] || {};

  const articulosOrdenados = [...articulos].sort((a, b) => {
    return (valoresPorArticulo[b] || 0) - (valoresPorArticulo[a] || 0);
  });

 // console.log("sucursalselec",sucursalesSeleccionadas);
  
  return (
    <Dialog fullScreen open={abrirDialog} onClose={handleClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Evolución mensual de despachos
          </Typography>
          <Button autoFocus color="inherit" onClick={handleClose}>
            Cerrar
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent>
        {/* LEYENDA */}
        <Box
          sx={{
            backgroundColor: "#DEDEDE",
            border: "1px solid black",
            borderRadius: 2,
            padding: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: `repeat(${Math.min(articulos.length, 6)}, 1fr)`,
              xl: `repeat(${Math.min(articulos.length, 8)}, 1fr)`,
            },
            columnGap: 2,
            rowGap: 1,
            mt: 2,
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              gridColumn: {
                xs: "span 2",
                sm: "span 2",
                md: "span 3",
                lg: `span ${Math.min(articulos.length, 6)}`,
                xl: `span ${Math.min(articulos.length, 8)}`,
              },
              color: "black",
            }}
          >
            Leyenda del gráfico
          </Typography>

          {articulosOrdenados.map((articulo) => (
            <Box
              key={articulo}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  backgroundColor: getColor(articulo),
                  marginRight: 1,
                  flexShrink: 0,
                  border: "1px solid #000",
                }}
              />
              <Typography variant="body2">
                {articulo} -{" "}
                <Box component="span" sx={{ fontWeight: "bold" }}>
                  Cant:{valoresPorArticulo[articulo] || 0}
                </Box>
              </Typography>
            </Box>
          ))}
        </Box>
        {/* GRAFICO */}
        <Paper elevation={10} sx={{ mt: 3 }}>
          <Typography
            align="center"
            sx={{
              fontWeight: "bold",
              fontSize: 20,
              textAlign: "center",
              mt: 1,
            }}
          >
            Despachos de: {sucursalesSeleccionadas[0].nombre}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: 300,
              width: "100%",
              p: 2,
            }}
          >
            <BarChart
              dataset={dataset}
              xAxis={[{ scaleType: "band", dataKey: "mes" }]}
              series={articulosOrdenados.map((articulo, index) => ({
                dataKey: articulo,
                label: articulo,
                valueFormatter,
                highlightScope: {
                  highlighted: "series",
                  faded: "global",
                },
                color: getColor(articulo),
              }))}
              {...chartSetting}
              {...customize}
            />
          </Box>
        </Paper>
      </DialogContent>
    </Dialog>
  );
}

export default Dialog_evolucion;
